<template>
  <div id="main_layout_v2" :class="$mq">
    <div id="main_header_container_v2">
      <MainHeaderV2 /> 
    </div>

    <div id="main_content">
      <slot></slot>
    </div>

    <div id="main_footer_container_v2">
      <MainFooterV2 />
    </div>
  </div>
</template>

<script>
import MainHeaderV2 from './MainHeaderV2'
import MainFooterV2 from './MainFooterV2'

export default{
  name: 'MainLayoutV2',
  components: {
    MainHeaderV2,
    MainFooterV2
  },

  props : {
    section : {
      type : String,
      required : true
    },
  }
}
</script>

<style scoped>
#main_layout_v2{
  position: relative;
  min-height: 100%;
  background-color: black;
}

#main_content{
  position: relative;
}

#main_header_container_v2{
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
}

#main_footer_container_v2{
  width: 100%;
  position: relative;
}
</style>
